import { render, staticRenderFns } from "./ReviewWorkDetails.vue?vue&type=template&id=58c03e73"
import script from "./ReviewWorkDetails.vue?vue&type=script&lang=js"
export * from "./ReviewWorkDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports